export const Download = ({ color = "#3d734a", size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V10.1893L12.4697 7.46967C12.7626 7.17678 13.2374 7.17678 13.5303 7.46967C13.8232 7.76256 13.8232 8.23744 13.5303 8.53033L9.53033 12.5303C9.23744 12.8232 8.76256 12.8232 8.46967 12.5303L4.46967 8.53033C4.17678 8.23744 4.17678 7.76256 4.46967 7.46967C4.76256 7.17678 5.23744 7.17678 5.53033 7.46967L8.25 10.1893V1.5C8.25 1.08579 8.58579 0.75 9 0.75Z"
      fill={color}
    />
    <path
      d="M1.5 12C1.91421 12 2.25 12.3358 2.25 12.75V14.25C2.25 14.6642 2.58579 15 3 15H15C15.4142 15 15.75 14.6642 15.75 14.25V12.75C15.75 12.3358 16.0858 12 16.5 12C16.9142 12 17.25 12.3358 17.25 12.75V14.25C17.25 15.4926 16.2426 16.5 15 16.5H3C1.75736 16.5 0.75 15.4926 0.75 14.25V12.75C0.75 12.3358 1.08579 12 1.5 12Z"
      fill={color}
    />
  </svg>
);

export const Copy = ({ color = "#3d734a", size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 1.5C5.50736 1.5 4.5 2.50736 4.5 3.75V11.25C4.5 12.4926 5.50736 13.5 6.75 13.5H12.75C13.9926 13.5 15 12.4926 15 11.25V5.68652C15 5.08978 14.7629 4.51748 14.341 4.09549L12.4045 2.15901C11.9825 1.73705 11.4102 1.5 10.8135 1.5H6.75ZM6 3.75C6 3.33579 6.33579 3 6.75 3H10.5V4.5C10.5 5.32843 11.1716 6 12 6H13.5V11.25C13.5 11.6642 13.1642 12 12.75 12H6.75C6.33579 12 6 11.6642 6 11.25V3.75Z"
      fill={color}
    />
    <path
      d="M3 5.25C2.58579 5.25 2.25 5.58579 2.25 6V14.25C2.25 15.4926 3.25736 16.5 4.5 16.5H11.25C11.6642 16.5 12 16.1642 12 15.75C12 15.3358 11.6642 15 11.25 15H4.5C4.08579 15 3.75 14.6642 3.75 14.25V6C3.75 5.58579 3.41421 5.25 3 5.25Z"
      fill={color}
    />
  </svg>
);

export const OlgaLogo = () => (
  <svg
    width="42"
    height="22"
    viewBox="0 0 42 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.4438 14.3221C23.7516 14.7248 23.0098 14.8585 22.24 14.7181C21.0757 14.5062 20.3065 13.5807 20.1824 12.2431C20.1714 12.123 20.1659 12.0017 20.1604 11.8749C20.1579 11.8157 20.1555 11.7554 20.1524 11.6932C20.2129 10.1623 20.6917 9.13265 21.6579 8.45464C22.4858 7.87332 23.6494 7.74646 24.552 8.13935C25.1586 8.40353 25.9241 9.01319 26.1296 10.4191C26.3681 12.0547 25.7065 13.5874 24.4438 14.3221ZM28.9589 6.06529H27.3428C27.1819 6.06529 27.0462 6.18414 27.0236 6.34425L26.8089 7.85361C26.4341 7.27228 26.0012 6.83136 25.4827 6.49698C23.8989 5.47473 21.6169 5.63792 20.0576 6.88494C18.4231 8.19169 17.69 10.0441 17.8789 12.3903C17.9902 13.771 18.5088 14.896 19.4217 15.7348C20.2869 16.5298 21.4163 16.9196 22.6026 16.8309C23.6262 16.7552 24.6076 16.3192 25.383 15.6116C25.2839 16.2059 25.1616 16.8131 24.9941 17.4129C24.5801 18.897 23.7485 19.6988 22.4516 19.8657C20.8366 20.0732 19.6858 19.5664 18.9294 18.3181C18.8909 18.2547 18.8493 18.2005 18.8053 18.1432C18.7857 18.118 18.7644 18.0909 18.7417 18.0601C18.6414 17.9246 18.4549 17.8889 18.3125 17.9782L17.0223 18.7843C16.8743 18.8767 16.826 19.0713 16.9134 19.2234C16.9397 19.2689 16.9629 19.3114 16.9849 19.3508C17.0326 19.437 17.0773 19.5189 17.1323 19.599C18.225 21.1927 19.8375 22.0001 21.9251 22.0001C21.9642 22.0001 22.004 22.0001 22.0431 21.9994C23.6017 21.9767 24.8718 21.4711 25.8165 20.4969C26.6438 19.6433 27.1526 18.557 27.4174 17.0779C27.7329 15.3173 28.0441 13.5252 28.3444 11.793C28.4728 11.0528 28.6012 10.3132 28.7302 9.57358L29.2763 6.44771C29.2928 6.35288 29.2671 6.25619 29.2053 6.1823C29.1448 6.10778 29.0543 6.06529 28.9589 6.06529Z"
      fill="black"
      fillOpacity="0.35"
    />
    <path
      d="M38.321 11.6924C38.1485 12.8748 37.6447 13.7154 36.7813 14.2616C35.8298 14.8638 34.8955 14.9476 34.0045 14.5098C33.1668 14.0978 32.7363 13.3508 32.6085 12.0865C32.6012 12.0151 32.6036 11.9344 32.6061 11.8494C32.6073 11.8033 32.6085 11.7577 32.6085 11.7121C32.6171 10.6104 32.8892 9.73228 33.4401 9.02841C34.0137 8.29497 34.9059 7.87992 35.817 7.91379C36.6431 7.94519 37.3683 8.34054 37.8067 8.99762C38.3081 9.74891 38.4763 10.6301 38.321 11.6924ZM41.3233 14.7592L41.2927 14.7425C41.2628 14.7253 41.201 14.6902 41.113 14.6883C41.0145 14.6865 40.9167 14.6846 40.8188 14.6834C40.6715 14.681 40.5247 14.6791 40.3774 14.6748C40.1756 14.6692 40.1358 14.6298 40.1352 14.6292C40.1352 14.6286 40.1004 14.583 40.1218 14.3767C40.1383 14.2135 40.1682 14.0504 40.2 13.8773L40.5314 11.9849C40.7192 10.9097 40.9069 9.83512 41.0928 8.7593C41.1839 8.23154 41.2707 7.70318 41.3582 7.1705L41.4774 6.44815C41.4933 6.35393 41.4664 6.25725 41.4052 6.18458C41.3441 6.11192 41.2536 6.06943 41.1588 6.06943H39.5464C39.3868 6.06943 39.251 6.18705 39.2272 6.34593L38.996 7.87992C38.3613 6.74497 37.4062 6.07805 36.1478 5.89454C34.2314 5.61373 32.5969 6.33238 31.418 7.97167C30.4274 9.34986 30.085 11.031 30.4005 12.969C30.6224 14.3293 31.2413 15.3756 32.2398 16.0782C32.9742 16.5949 33.8046 16.8443 34.6337 16.8437C35.8255 16.8437 37.0148 16.3289 37.9119 15.351C38.0195 16.013 38.439 16.4354 39.1202 16.5549C39.5451 16.6294 39.9756 16.6343 40.3914 16.6392C40.5229 16.6405 40.6537 16.6423 40.7846 16.646C40.9833 16.6479 41.2444 16.4859 41.2927 16.2556C41.3539 15.9594 41.4028 15.6619 41.4505 15.3744L41.4957 15.1034C41.519 14.963 41.4493 14.8238 41.3233 14.7592Z"
      fill="black"
      fillOpacity="0.35"
    />
    <path
      d="M6.16789 14.7601C4.36464 14.7594 3.26582 13.9804 2.9026 12.4465C2.51676 10.8195 3.22607 9.01207 4.51874 8.33221C5.08007 8.03662 5.6249 7.88944 6.14955 7.88944C6.72495 7.88944 7.2765 8.0668 7.79992 8.42212C8.78134 9.08781 9.19715 10.1267 9.03694 11.5104C8.96662 12.1133 8.78012 12.7193 8.51046 13.2175C7.90449 14.3345 6.90411 14.7471 6.16789 14.7601ZM6.14465 5.82031C6.12937 5.82031 6.11347 5.82031 6.09818 5.82031C4.6184 5.82031 3.22668 6.39302 2.17617 7.43682C1.10425 8.50156 0.508664 9.93209 0.500104 11.4648C0.482371 14.5063 2.74117 16.8138 5.75575 16.8323C5.76798 16.8323 5.7796 16.8323 5.79122 16.8323C7.28323 16.8323 8.67556 16.262 9.7163 15.2244C10.7784 14.1658 11.3667 12.7297 11.3722 11.181C11.3838 8.1487 9.13661 5.84433 6.14465 5.82031Z"
      fill="black"
      fillOpacity="0.35"
    />
    <path
      d="M16.0955 14.6744C15.9744 14.6744 15.8576 14.675 15.7433 14.6762C15.4981 14.6781 15.2657 14.6799 15.037 14.6725C14.9086 14.6682 14.8719 14.6497 14.867 14.6485C14.864 14.6423 14.8468 14.6011 14.8511 14.4785C14.8542 14.3775 14.8725 14.2679 14.8921 14.1552L14.8976 14.1238C15.2639 12.0362 15.6295 9.948 15.9982 7.8604C16.3077 6.10903 16.9815 2.20601 17.2151 0.849989C17.2512 0.638766 17.1931 0.424464 17.0555 0.260658C16.9185 0.0980836 16.7241 0.00755891 16.507 0.00632728C16.1951 0.00879053 15.9359 0.00940657 15.6729 0.000785195C15.2853 -0.0139943 15.0468 0.179985 14.9832 0.572874C14.8591 1.33463 14.2195 4.98825 13.6012 8.52117C13.2625 10.4573 12.9341 12.3349 12.7097 13.6263C12.6168 14.1614 12.5776 14.6682 12.5935 15.1325C12.6192 15.8783 13.0662 16.4103 13.7608 16.5212C14.2354 16.5969 14.7215 16.6283 15.1911 16.6585C15.3972 16.6721 15.6045 16.685 15.8142 16.7022C15.8227 16.7028 15.8319 16.7035 15.8405 16.7035C15.9946 16.7035 16.1285 16.5926 16.1572 16.438L16.4128 15.0586C16.4306 14.9638 16.4049 14.8659 16.3437 14.7914C16.2826 14.7175 16.1915 14.6744 16.0955 14.6744Z"
      fill="black"
      fillOpacity="0.35"
    />
  </svg>
);

export const ForkKnife = () => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.99965 0.454691L12.8282 10.9876L11.769 12.047L2.01071 1.59376C1.80448 2.29689 1.49983 3.61409 1.49983 5.25004C1.49983 7.17192 2.09038 8.63443 3.21525 10.1532C4.19951 11.4798 5.56342 12.8204 7.30697 14.522C7.61631 14.822 7.93502 15.136 8.26779 15.4642L8.27248 15.4689L8.30998 15.5064L7.25072 16.5657L7.21323 16.5282C6.89452 16.2142 6.58049 15.9048 6.27584 15.6095C4.54166 13.9126 3.07464 12.4782 2.01071 11.0438C0.731166 9.31881 0 7.55161 0 5.25004C0 3.26252 0.403078 1.69689 0.637426 0.956256C0.824905 0.356252 1.37797 0 1.95446 0C2.35285 0 2.72781 0.164064 2.99965 0.454691ZM22.6989 23.7611L14.8389 15.3423L15.8982 14.2829L23.7957 22.7392C24.0769 23.0439 24.0628 23.5173 23.7582 23.7986C23.4535 24.0798 22.9802 24.0658 22.6989 23.7611ZM21.9771 0.30469C22.2209 0.637504 22.1506 1.10626 21.8178 1.3547L16.4559 5.28285C16.3106 5.39066 16.17 5.50785 16.0435 5.6391L15.9685 5.7141C15.3498 6.33754 14.9983 7.1813 14.9983 8.06255C14.9983 8.94381 15.3498 9.78757 15.9732 10.411L16.5871 11.0251C17.2105 11.6485 18.0542 12.0001 18.9353 12.0001C19.8165 12.0001 20.6601 11.6485 21.2835 11.0251L21.3585 10.9501C21.485 10.8235 21.6069 10.6829 21.7147 10.5376L25.6423 5.17972C25.8861 4.84691 26.3548 4.77191 26.6922 5.02035C27.0297 5.26878 27.1 5.73285 26.8516 6.07035L22.9239 11.4282C22.7692 11.6345 22.6005 11.8313 22.4224 12.0141L22.3474 12.0891C21.4428 12.9938 20.2149 13.5001 18.9353 13.5001C17.7636 13.5001 16.634 13.0735 15.7576 12.3048L4.27919 23.7798C3.9886 24.0705 3.51053 24.0705 3.21994 23.7798C2.92935 23.4892 2.92935 23.0111 3.21994 22.7205L14.6936 11.2407C13.925 10.3641 13.4984 9.23444 13.4984 8.06255C13.4984 6.78286 14.0046 5.55472 14.9092 4.65003L14.9842 4.57503C15.167 4.39222 15.3638 4.22347 15.5701 4.07346L20.9273 0.145313C21.26 -0.0984382 21.7287 -0.0281252 21.9771 0.30469ZM23.8097 1.75782C24.0816 2.07189 24.0488 2.54533 23.7394 2.81721L17.7401 8.06724C17.4261 8.33912 16.9527 8.30631 16.6809 7.99693C16.409 7.68755 16.4418 7.20942 16.7512 6.93755L22.7505 1.68751C23.0598 1.41563 23.5379 1.44845 23.8097 1.75782ZM25.2393 3.18752C25.5486 3.4594 25.5814 3.93284 25.3096 4.2469L20.0602 10.2469C19.7883 10.561 19.315 10.5891 19.0009 10.3173C18.6869 10.0454 18.6588 9.57194 18.9306 9.25787L24.18 3.25783C24.4519 2.94377 24.9252 2.91564 25.2393 3.18752Z"
      fill="#3D734A"
    />
  </svg>
);

export const Star = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.20572 7.91345L11.9973 1.98305L14.7889 7.91345C14.9981 8.35882 15.4073 8.66823 15.8847 8.74324L22.1317 9.69491L17.5942 14.3267C17.2578 14.6689 17.1032 15.1612 17.185 15.6441L18.2535 22.1839L12.6839 19.1132C12.2565 18.8788 11.7427 18.8788 11.3108 19.1132L5.73666 22.1839L6.80511 15.6441C6.8824 15.1612 6.73236 14.6736 6.39591 14.3267L1.86295 9.69491L8.10998 8.74324C8.58738 8.67291 8.99657 8.35882 9.20572 7.91345ZM18.2262 23.8669C18.5945 24.0685 19.04 24.0404 19.3765 23.7872C19.7129 23.5341 19.8857 23.1075 19.8175 22.6855L18.6217 15.3956L23.6776 10.2294C23.9731 9.92932 24.0731 9.48395 23.9458 9.08078C23.8185 8.6776 23.4775 8.38225 23.0683 8.31662L16.0984 7.25712L12.9794 0.632888C12.7975 0.243779 12.4156 0 11.9973 0C11.579 0 11.1971 0.243779 11.0153 0.632888L7.89629 7.25712L0.930895 8.32131C0.521701 8.38226 0.180705 8.6776 0.0534003 9.08546C-0.0739046 9.49333 0.0306673 9.934 0.32165 10.234L5.37293 15.3956L4.18172 22.6855C4.11352 23.1075 4.28174 23.5341 4.62274 23.7872C4.96373 24.0404 5.4093 24.0685 5.77303 23.8669L12.0019 20.4353L18.2307 23.8669H18.2262Z"
      fill="#3D734A"
    />
  </svg>
);

export const Calendar = () => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 0C5.6625 0 6 0.3375 6 0.75V3H15V0.75C15 0.3375 15.3375 0 15.75 0C16.1625 0 16.5 0.3375 16.5 0.75V3H18C19.6547 3 21 4.34531 21 6V7.5V9V21C21 22.6547 19.6547 24 18 24H3C1.34531 24 0 22.6547 0 21V9V7.5V6C0 4.34531 1.34531 3 3 3H4.5V0.75C4.5 0.3375 4.8375 0 5.25 0ZM19.5 9H1.5V21C1.5 21.8297 2.17031 22.5 3 22.5H18C18.8297 22.5 19.5 21.8297 19.5 21V9ZM18 4.5H3C2.17031 4.5 1.5 5.17031 1.5 6V7.5H19.5V6C19.5 5.17031 18.8297 4.5 18 4.5Z"
      fill="#3D734A"
    />
  </svg>
);

export const Invoice = ({ color = "#3d734a", size = 18 }) => (
  <svg
    width={size}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.242 0.188773C1.02172 -0.00807254 0.707705 -0.0549404 0.440558 0.0669161C0.173411 0.188773 0 0.455919 0 0.751187V23.2478C0 23.543 0.173411 23.8102 0.440558 23.932C0.707705 24.0539 1.02172 24.007 1.242 23.8149L3.71194 21.6543L5.83974 23.7821C6.13032 24.0726 6.60837 24.0726 6.89895 23.7821L8.99863 21.6824L11.0936 23.7774C11.3842 24.068 11.8623 24.068 12.1528 23.7774L14.2806 21.6496L16.7553 23.8102C16.9755 24.0023 17.2896 24.0492 17.5567 23.9274C17.8239 23.8055 17.9973 23.5384 17.9973 23.2431V0.751187C17.9973 0.455919 17.8239 0.188773 17.5567 0.0669161C17.2896 -0.0549404 16.9755 -0.00807254 16.7553 0.188773L14.2806 2.34938L12.1528 0.22158C11.8623 -0.0690008 11.3842 -0.0690008 11.0936 0.22158L8.99863 2.31657L6.90364 0.22158C6.61306 -0.0690008 6.13501 -0.0690008 5.84442 0.22158L3.71662 2.34938L1.242 0.188773ZM1.49977 21.5933V2.40562L3.25732 3.9382C3.55259 4.19598 4.00252 4.18192 4.27904 3.9054L6.37403 1.8104L8.46903 3.9054C8.75961 4.19598 9.23766 4.19598 9.52824 3.9054L11.6232 1.8104L13.7182 3.9054C13.9994 4.1866 14.4447 4.20066 14.7399 3.9382L16.4975 2.40562V21.5933L14.7399 20.0608C14.4447 19.803 13.9948 19.817 13.7182 20.0936L11.6232 22.1886L9.52824 20.0936C9.23766 19.803 8.75961 19.803 8.46903 20.0936L6.37403 22.1886L4.27904 20.0936C3.99783 19.8124 3.55259 19.7983 3.25732 20.0608L1.49977 21.5933ZM4.49932 6.75028C4.08688 6.75028 3.74943 7.08772 3.74943 7.50016C3.74943 7.9126 4.08688 8.25005 4.49932 8.25005H13.4979C13.9104 8.25005 14.2478 7.9126 14.2478 7.50016C14.2478 7.08772 13.9104 6.75028 13.4979 6.75028H4.49932ZM3.74943 16.4988C3.74943 16.9112 4.08688 17.2487 4.49932 17.2487H13.4979C13.9104 17.2487 14.2478 16.9112 14.2478 16.4988C14.2478 16.0864 13.9104 15.7489 13.4979 15.7489H4.49932C4.08688 15.7489 3.74943 16.0864 3.74943 16.4988ZM4.49932 11.2496C4.08688 11.2496 3.74943 11.587 3.74943 11.9995C3.74943 12.4119 4.08688 12.7494 4.49932 12.7494H13.4979C13.9104 12.7494 14.2478 12.4119 14.2478 11.9995C14.2478 11.587 13.9104 11.2496 13.4979 11.2496H4.49932Z"
      fill={color}
    />
  </svg>
);

export const Check = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6211 1.25391C15.1719 1.80469 15.1719 2.69531 14.6211 3.24023L7.12109 10.7461C6.57031 11.2969 5.67969 11.2969 5.13477 10.7461L1.38477 6.99609C0.833984 6.44531 0.833984 5.55469 1.38477 5.00977C1.93555 4.46484 2.82617 4.45898 3.37109 5.00977L6.125 7.76367L12.6289 1.25391C13.1797 0.703125 14.0703 0.703125 14.6152 1.25391H14.6211Z"
      fill="#3D734A"
    />
  </svg>
);

export const Plus = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 1.5V11.5"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 6.5H11.5"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Minus = () => (
  <svg
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2H14"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Times = ({ color = "#8f8f8f" }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.78484 6L11.8244 1.96056C12.058 1.72694 12.058 1.34782 11.8244 1.11383L10.8858 0.175216C10.6521 -0.0584053 10.273 -0.0584053 10.039 0.175216L5.99981 4.21503L1.96025 0.175591C1.72662 -0.0580303 1.34749 -0.0580303 1.11349 0.175591L0.175221 1.11383C-0.0584072 1.34745 -0.0584072 1.72657 0.175221 1.96056L4.21478 6L0.175221 10.0394C-0.0584072 10.2731 -0.0584072 10.6522 0.175221 10.8862L1.11386 11.8248C1.34749 12.0584 1.72662 12.0584 1.96062 11.8248L5.99981 7.78497L10.0394 11.8244C10.273 12.058 10.6521 12.058 10.8861 11.8244L11.8248 10.8858C12.0584 10.6522 12.0584 10.2731 11.8248 10.0391L7.78484 6Z"
      fill={color}
      fillOpacity="1"
    />
  </svg>
);

export const ArrowLeft = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 9H1.75"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 15.75L1.75 9L8.5 2.25"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2.25L9 15.75"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 9L9 15.75L2.25 9"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Bag = ({ size = 20 }) => (
  <svg
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.20894 1.17647C5.56703 1.17647 4.00994 1.90577 2.95881 3.16712V3.16712C2.13026 4.16138 1.67651 5.41466 1.67651 6.70889V17.0588C1.67651 17.5269 1.8831 17.9757 2.25081 18.3067C2.61853 18.6376 3.11727 18.8235 3.6373 18.8235H17.3628C17.8828 18.8235 18.3816 18.6376 18.7493 18.3067C19.117 17.9757 19.3236 17.5269 19.3236 17.0588V6.7089C19.3236 5.41466 18.8698 4.16138 18.0413 3.16712V3.16712C16.9901 1.90577 15.4331 1.17647 13.7911 1.17647H7.20894Z"
      stroke="#8C8C8C"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.77954 5.09825L18.2207 5.09825"
      stroke="#8C8C8C"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4215 8.23557C14.4215 9.17163 14.0083 10.0694 13.2729 10.7312C12.5375 11.3931 11.54 11.765 10.4999 11.765C9.45987 11.765 8.46241 11.3931 7.72697 10.7312C6.99153 10.0694 6.57837 9.17163 6.57837 8.23557"
      stroke="#8C8C8C"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoPicture = () => (
  <svg
    width="154"
    height="154"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.2222 1H3.77778C2.24365 1 1 2.24365 1 3.77778V23.2222C1 24.7563 2.24365 26 3.77778 26H23.2222C24.7563 26 26 24.7563 26 23.2222V3.77778C26 2.24365 24.7563 1 23.2222 1Z"
      stroke="#DDD"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.6388 10.7223C9.78939 10.7223 10.7221 9.78959 10.7221 8.639C10.7221 7.4884 9.78939 6.55566 8.6388 6.55566C7.48821 6.55566 6.55547 7.4884 6.55547 8.639C6.55547 9.78959 7.48821 10.7223 8.6388 10.7223Z"
      stroke="#DDD"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.0002 17.6661L22.5913 14.2572C20.6387 12.3046 17.4729 12.3046 15.5203 14.2572L3.77801 25.9995"
      stroke="#DDD"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Edit = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="32"
      height="32"
      rx="16"
      stroke="black"
      strokeOpacity="0.05"
      strokeWidth="2"
    />
    <path
      d="M21.9303 9.37359C22.2611 9.04273 22.7961 9.04273 23.1235 9.37359L24.6229 10.873C24.9537 11.2039 24.9537 11.7389 24.6229 12.0662L22.6976 13.9986L20.0014 11.3024L21.9303 9.37359ZM19.206 12.0979L21.9021 14.794L13.6165 23.0761C13.349 23.3436 13.0217 23.5372 12.6592 23.6428L9.39282 24.6072L10.3537 21.3408C10.4593 20.9783 10.6564 20.651 10.9204 20.3835L19.206 12.0979ZM23.9225 8.57812C23.1516 7.80729 21.9056 7.80729 21.1348 8.57812L10.1249 19.5845C9.72368 19.9857 9.43153 20.4785 9.27314 21.0205L8.02362 25.2795C7.96379 25.4766 8.0201 25.6913 8.16441 25.8356C8.30873 25.9799 8.52343 26.0362 8.72054 25.9764L12.9795 24.7233C13.5215 24.5649 14.0143 24.2693 14.4155 23.8715L25.4219 12.8652C26.1927 12.0944 26.1927 10.8484 25.4219 10.0775L23.9225 8.57812Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const TrashCircle = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        stroke="black"
        strokeOpacity="0.15"
      />
      <path d="M10 11.3999H11.2222H21" />
      <path
        d="M10 11.3999H11.2222H21"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M19.7763 11.4V19.8C19.7763 20.1183 19.6475 20.4235 19.4183 20.6485C19.1891 20.8736 18.8782 21 18.554 21H12.4429C12.1188 21 11.8079 20.8736 11.5787 20.6485C11.3495 20.4235 11.2207 20.1183 11.2207 19.8V11.4M13.054 11.4V10.2C13.054 9.88174 13.1828 9.57652 13.412 9.35147C13.6412 9.12643 13.9521 9 14.2763 9H16.7207C17.0449 9 17.3557 9.12643 17.5849 9.35147C17.8142 9.57652 17.9429 9.88174 17.9429 10.2V11.4" />
      <path
        d="M19.7763 11.4V19.8C19.7763 20.1183 19.6475 20.4235 19.4183 20.6485C19.1891 20.8736 18.8782 21 18.554 21H12.4429C12.1188 21 11.8079 20.8736 11.5787 20.6485C11.3495 20.4235 11.2207 20.1183 11.2207 19.8V11.4M13.054 11.4V10.2C13.054 9.88174 13.1828 9.57652 13.412 9.35147C13.6412 9.12643 13.9521 9 14.2763 9H16.7207C17.0449 9 17.3557 9.12643 17.5849 9.35147C17.8142 9.57652 17.9429 9.88174 17.9429 10.2V11.4"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarBlank = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M11.9983 0C12.4166 0 12.7985 0.246139 12.9804 0.633866L16.0993 7.25758L23.0691 8.32184C23.4783 8.38279 23.8148 8.67815 23.9466 9.08135C24.0739 9.48924 23.9693 9.93463 23.6784 10.23L18.6226 15.3966L19.8183 22.687C19.8865 23.1089 19.7183 23.5403 19.3773 23.7887C19.0409 24.0372 18.5544 24.07 18.2271 23.8684L11.9983 20.4366L5.73319 23.8684C5.40584 24.07 4.96028 24.0372 4.61929 23.7887C4.28285 23.5403 4.11463 23.1089 4.14191 22.687L5.37402 15.3966L0.323276 10.23C0.0295696 9.93463 -0.074546 9.48924 0.0545755 9.08135C0.183242 8.67815 0.522868 8.38279 0.931602 8.32184L7.89734 7.25758L11.0163 0.633866C11.2027 0.246092 11.58 0 11.9983 0ZM11.9983 3.70146L9.61139 8.77661C9.45226 9.10948 9.14309 9.3439 8.78846 9.40016L3.40901 10.2159L7.31539 14.2057C7.56545 14.4636 7.67911 14.834 7.62001 15.195L6.70161 20.8023L11.4846 18.1674C11.8074 17.9892 12.1938 17.9892 12.5121 18.1674L17.295 20.8023L16.3766 15.195C16.3175 14.834 16.4357 14.4636 16.6858 14.2057L20.5913 10.2159L15.2127 9.40016C14.8535 9.3439 14.5444 9.10948 14.3898 8.77661L11.9983 3.70146Z"
        fill="#8C8C8C"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StarRed = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3057 0.843656C13.0648 0.328088 12.5558 0 11.9967 0C11.4377 0 10.9332 0.328088 10.6878 0.843656L7.76537 7.04452L1.2388 8.03816C0.693401 8.12253 0.238904 8.51623 0.0707399 9.05524C-0.0974239 9.59424 0.038925 10.1895 0.429792 10.5879L5.16565 15.4201L4.04759 22.2491C3.95669 22.8115 4.18394 23.3833 4.63389 23.7161C5.08384 24.0489 5.67923 24.0911 6.17009 23.8239L12.0013 20.6133L17.8325 23.8239C18.3233 24.0911 18.9187 24.0536 19.3687 23.7161C19.8186 23.3786 20.0459 22.8115 19.955 22.2491L18.8324 15.4201L23.5682 10.5879C23.9591 10.1895 24.1 9.59424 23.9273 9.05524C23.7546 8.51623 23.3046 8.12253 22.7592 8.03816L16.2281 7.04452L13.3057 0.843656Z"
      fill="#FF502D"
    />
  </svg>
);

export const StarGold = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M13.3057 0.843656C13.0648 0.328088 12.5558 0 11.9967 0C11.4377 0 10.9332 0.328088 10.6878 0.843656L7.76537 7.04452L1.2388 8.03816C0.693401 8.12253 0.238904 8.51623 0.0707399 9.05524C-0.0974239 9.59424 0.038925 10.1895 0.429792 10.5879L5.16565 15.4201L4.04759 22.2491C3.95669 22.8115 4.18394 23.3833 4.63389 23.7161C5.08384 24.0489 5.67923 24.0911 6.17009 23.8239L12.0013 20.6133L17.8325 23.8239C18.3233 24.0911 18.9187 24.0536 19.3687 23.7161C19.8186 23.3786 20.0459 22.8115 19.955 22.2491L18.8324 15.4201L23.5682 10.5879C23.9591 10.1895 24.1 9.59424 23.9273 9.05524C23.7546 8.51623 23.3046 8.12253 22.7592 8.03816L16.2281 7.04452L13.3057 0.843656Z"
        fill="#FFC741"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RoundedStar = () => (
  <svg
    width="33"
    height="36"
    viewBox="0 0 33 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.7961 30.2301L24.7995 30.2314C25.2464 30.4053 25.7379 30.4339 26.2029 30.3127C26.6666 30.187 27.0778 29.9183 27.3771 29.546L27.3829 29.5389L27.3829 29.5389C27.6889 29.1724 27.8672 28.7183 27.8923 28.2443C27.9174 27.7704 27.7879 27.3011 27.523 26.9059L27.5199 26.9013L27.5199 26.9013L24.8759 22.8611L24.7961 30.2301ZM24.7961 30.2301L20.2642 28.5038M24.7961 30.2301L20.2642 28.5038M20.2642 28.5038C20.2639 28.5037 20.2636 28.5036 20.2633 28.5034C19.7882 28.3214 19.2677 28.2939 18.7765 28.4245C18.2851 28.5552 17.848 28.8374 17.5283 29.231M20.2642 28.5038L17.5283 29.231M17.5283 29.231C17.5282 29.2311 17.5281 29.2312 17.528 29.2314L14.473 32.975L14.8615 33.2913L14.473 32.975C14.171 33.3452 13.7582 33.6113 13.2939 33.7348C12.8295 33.8583 12.338 33.8327 11.8899 33.662C11.4418 33.4914 11.0603 33.1846 10.7996 32.7862C10.5388 32.3879 10.4119 31.918 10.4369 31.4437C10.4369 31.4437 10.4369 31.4437 10.4369 31.4437L10.691 26.6329C10.691 26.6326 10.691 26.6324 10.6911 26.6321C10.7186 26.1262 10.5836 25.6245 10.3055 25.1995C10.0274 24.7745 9.62095 24.4486 9.14516 24.2681C9.14498 24.268 9.1448 24.268 9.14463 24.2679L4.61238 22.5415L4.43528 23.0081L4.61237 22.5415C4.1643 22.3708 3.78282 22.064 3.5221 21.6656C3.2614 21.2673 3.13451 20.7973 3.15955 20.323C3.1846 19.8486 3.36038 19.3936 3.66242 19.0235C3.96449 18.6533 4.37722 18.3872 4.8416 18.2637L9.53095 17.0168C9.53114 17.0167 9.53132 17.0167 9.5315 17.0166L9.53183 17.0166L9.40149 16.5338C9.79146 16.4309 10.1384 16.2078 10.3924 15.8966C10.6463 15.5854 10.7942 15.2022 10.8146 14.8023M17.5283 29.231L11.3144 14.83L11.3143 14.8302L10.8146 14.8023M10.8146 14.8023L11.3144 14.8293L11.5683 10.0185L11.5683 10.0184C11.5933 9.54401 11.7691 9.08899 12.0712 8.7188C12.3733 8.34856 12.7861 8.08237 13.2505 7.95888C13.7149 7.83539 14.2065 7.8611 14.6547 8.03184C15.1028 8.20256 15.4843 8.5094 15.745 8.90785L15.745 8.90788L18.3888 12.9482M10.8146 14.8023L11.0685 9.99053C11.0991 9.41013 11.3141 8.85427 11.6827 8.40259C12.0512 7.95091 12.5544 7.62659 13.1201 7.47617C13.6859 7.32574 14.285 7.35694 14.8318 7.56524C15.3785 7.77354 15.8448 8.14825 16.1637 8.6357L18.8081 12.6768M18.8081 12.6768L18.3888 12.9482M18.8081 12.6768L18.3893 12.9489L18.3888 12.9482M18.8081 12.6768L18.3888 12.9482M18.3888 12.9482C18.6663 13.3738 19.0723 13.7004 19.548 13.8816C20.0234 14.0627 20.544 14.0892 21.035 13.9578L21.0346 13.9579L20.9043 13.4752L21.0355 13.9577L18.3888 12.9482ZM25.0235 20.0457L25.023 20.0463C24.702 20.4386 24.5142 20.9225 24.4876 21.4284C24.4609 21.9344 24.5967 22.4358 24.8754 22.8603L25.0235 20.0457Z"
      fill="#8C8C8C"
      stroke="#8C8C8C"
    />
    <line
      x1="1"
      y1="-1"
      x2="4.63261"
      y2="-1"
      transform="matrix(0.966419 0.256973 -0.260676 0.965426 2.12402 13.4287)"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="1"
      y1="-1"
      x2="4.614"
      y2="-1"
      transform="matrix(-0.709813 0.704391 -0.709813 -0.70439 23.0859 4.95996)"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="1"
      y1="-1"
      x2="4.59533"
      y2="-1"
      transform="matrix(0.260677 0.965426 -0.966419 0.256973 9.70703 1)"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckSuccess = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" fill="#3D734A" fillOpacity="0.1" />
    <path
      d="M35.3915 19.6499C35.9695 19.082 35.9695 18.149 35.3915 17.581C34.8208 17.0203 33.8942 17.0203 33.3235 17.581L22.1213 28.5879L16.6773 23.2388C16.1066 22.6781 15.18 22.6781 14.6093 23.2388C14.0313 23.8068 14.0313 24.7397 14.6093 25.3077L21.0873 31.6727C21.658 32.2335 22.5846 32.2335 23.1553 31.6727L35.3915 19.6499Z"
      fill="#3D734A"
      stroke="#3D734A"
      strokeWidth="1.5"
    />
  </svg>
);

export const ChevronLeft = ({ color = "#8f8f8f" }) => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11L1 6L6 1"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDown = () => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 18 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6114 0.799783L15.9485 1.16275L15.6114 0.799784L9 6.94021L2.38859 0.799784C1.95822 0.400072 1.269 0.400072 0.838626 0.799784C0.387125 1.21912 0.387125 1.92067 0.838626 2.34001L8.22502 9.20022C8.65539 9.59993 9.34461 9.59993 9.77498 9.20022L17.1614 2.34001C17.6129 1.92067 17.6129 1.21912 17.1614 0.799784C16.731 0.400072 16.0418 0.400073 15.6114 0.799783Z"
      fill="#8C8C8C"
      stroke="#8C8C8C"
    />
  </svg>
);

export const ChevronUp = () => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 18 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.38859 9.20022L2.05148 8.83725L2.38859 9.20021L9 3.05979L15.6114 9.20022C16.0418 9.59993 16.731 9.59993 17.1614 9.20022C17.6129 8.78088 17.6129 8.07933 17.1614 7.65999L9.77498 0.799784C9.34461 0.400071 8.65539 0.400071 8.22502 0.799784L0.838627 7.65999C0.387125 8.07933 0.387125 8.78088 0.838627 9.20021C1.269 9.59993 1.95822 9.59993 2.38859 9.20022Z"
      fill="#8C8C8C"
      stroke="#8C8C8C"
    />
  </svg>
);

export const ChevronRight = ({ color = "#3D734A" }) => {
  return (
    <svg
      width="7"
      height="11"
      viewBox="0 0 7 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2186 1.07092L1.07258 1.21356C0.975808 1.3081 0.975808 1.46138 1.07258 1.55594L5.10967 5.50001L1.07258 9.44407C0.975808 9.53861 0.975808 9.6919 1.07258 9.78646L1.2186 9.9291C1.31537 10.0236 1.47227 10.0236 1.56904 9.9291L5.92742 5.67119C6.02419 5.57665 6.02419 5.42336 5.92742 5.3288L1.56904 1.07092C1.47227 0.97636 1.31537 0.97636 1.2186 1.07092Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export const Search = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5016 9.93837C17.5016 8.94515 17.306 7.96166 16.9259 7.04405C16.5458 6.12643 15.9887 5.29267 15.2864 4.59036C14.5841 3.88804 13.7503 3.33094 12.8327 2.95085C11.9151 2.57076 10.9316 2.37513 9.93837 2.37513C8.94515 2.37513 7.96166 2.57076 7.04405 2.95085C6.12643 3.33094 5.29267 3.88804 4.59036 4.59036C3.88804 5.29267 3.33094 6.12643 2.95085 7.04405C2.57076 7.96166 2.37513 8.94515 2.37513 9.93837C2.37513 10.9316 2.57076 11.9151 2.95085 12.8327C3.33094 13.7503 3.88804 14.5841 4.59036 15.2864C5.29267 15.9887 6.12643 16.5458 7.04405 16.9259C7.96166 17.306 8.94515 17.5016 9.93837 17.5016C10.9316 17.5016 11.9151 17.306 12.8327 16.9259C13.7503 16.5458 14.5841 15.9887 15.2864 15.2864C15.9887 14.5841 16.5458 13.7503 16.9259 12.8327C17.306 11.9151 17.5016 10.9316 17.5016 9.93837ZM15.7526 16.7281C14.1927 18.0689 12.1601 18.8767 9.93837 18.8767C5.00078 18.8767 1 14.876 1 9.93837C1 5.00078 5.00078 1 9.93837 1C14.876 1 18.8767 5.00078 18.8767 9.93837C18.8767 12.1601 18.0689 14.1927 16.7281 15.7526L22.8002 21.829C23.0666 22.0954 23.0666 22.5337 22.8002 22.8002C22.5337 23.0666 22.0954 23.0666 21.829 22.8002L15.7526 16.7281Z"
      fill="#3D734A"
      stroke="#3D734A"
    />
  </svg>
);

export const Erase = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM6.15234 6.15234C6.48281 5.82188 7.01719 5.82188 7.34414 6.15234L8.99648 7.80469L10.6488 6.15234C10.9793 5.82188 11.5137 5.82188 11.8406 6.15234C12.1676 6.48281 12.1711 7.01719 11.8406 7.34414L10.1883 8.99648L11.8406 10.6488C12.1711 10.9793 12.1711 11.5137 11.8406 11.8406C11.5102 12.1676 10.9758 12.1711 10.6488 11.8406L8.99648 10.1883L7.34414 11.8406C7.01367 12.1711 6.4793 12.1711 6.15234 11.8406C5.82539 11.5102 5.82188 10.9758 6.15234 10.6488L7.80469 8.99648L6.15234 7.34414C5.82188 7.01367 5.82188 6.4793 6.15234 6.15234Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const InfoCircle = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z"
      fill="#3D734A"
      fill-opacity="0.15"
    />
    <path
      d="M25.3698 35.8217C19.1869 35.8217 14.1758 30.8106 14.1758 24.6276C14.1758 18.4447 19.1869 13.4336 25.3698 13.4336C31.5528 13.4336 36.5638 18.4447 36.5638 24.6276C36.5638 30.8106 31.5528 35.8217 25.3698 35.8217ZM25.3698 14.8328C19.9608 14.8328 15.575 19.2186 15.575 24.6276C15.575 30.0366 19.9608 34.4224 25.3698 34.4224C30.7788 34.4224 35.1646 30.0366 35.1646 24.6276C35.1646 19.2186 30.7788 14.8328 25.3698 14.8328ZM25.3698 30.2246C24.7882 30.2246 24.3204 29.7568 24.3204 29.1752C24.3204 28.5936 24.7882 28.1258 25.3698 28.1258C25.9514 28.1258 26.4193 28.5936 26.4193 29.1752C26.4193 29.7568 25.9514 30.2246 25.3698 30.2246ZM25.3698 19.0306C25.9601 19.0306 26.4324 19.5291 26.3974 20.1194L26.0651 26.0662C26.0432 26.4379 25.7371 26.7265 25.3654 26.7265C24.9938 26.7265 24.6877 26.4379 24.6658 26.0662L24.3335 20.1194C24.2985 19.5291 24.7708 19.0306 25.3611 19.0306H25.3698Z"
      fill="#3D734A"
    />
  </svg>
);

export const ArrowLeftCircle = () => (
  <svg
    width="55"
    height="54"
    viewBox="0 0 55 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.75"
      y="0.75"
      width="53.5"
      height="52.5"
      rx="26.25"
      fill="#FCFCFC"
    />
    <rect
      x="0.75"
      y="0.75"
      width="53.5"
      height="52.5"
      rx="26.25"
      stroke="#3D734A"
      strokeWidth="1.5"
    />
    <path
      d="M34.25 27H20.75"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.5 33.75L20.75 27L27.5 20.25"
      stroke="#3D734A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Kid = () => (
  <svg
    width="93"
    height="93"
    viewBox="0 0 93 93"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H53C71.8562 0 81.2843 0 87.1421 5.85786C93 11.7157 93 21.1438 93 40V53C93 71.8562 93 81.2843 87.1421 87.1421C81.2843 93 71.8562 93 53 93H40C21.1438 93 11.7157 93 5.85786 87.1421C0 81.2843 0 71.8562 0 53V40Z"
      fill="#3D734A"
      fill-opacity="0.1"
    />
    <path
      d="M46.9483 62.8942C44.9606 62.8942 43.166 62.3416 41.5643 61.2362C39.9621 60.1308 38.7885 58.6839 38.0433 56.8954H55.8906C55.1206 58.6839 53.9345 60.1308 52.3323 61.2362C50.7307 62.3416 48.936 62.8942 46.9483 62.8942ZM40.2371 49.9651C39.7433 49.9651 39.3039 49.7836 38.9189 49.4204C38.5339 49.0578 38.3413 48.6293 38.3413 48.135C38.3413 47.6411 38.5279 47.2079 38.901 46.8353C39.2741 46.4627 39.715 46.2764 40.2237 46.2764C40.7324 46.2764 41.1731 46.4642 41.5457 46.8398C41.9183 47.2149 42.1046 47.6496 42.1046 48.1439C42.1046 48.6377 41.9168 49.0647 41.5412 49.4249C41.1661 49.7851 40.7314 49.9651 40.2371 49.9651ZM53.6506 49.9651C53.1568 49.9651 52.7298 49.7836 52.3696 49.4204C52.0094 49.0578 51.8293 48.6293 51.8293 48.135C51.8293 47.6411 52.0109 47.2079 52.3741 46.8353C52.7367 46.4627 53.1652 46.2764 53.6595 46.2764C54.1533 46.2764 54.5865 46.4642 54.9591 46.8398C55.3317 47.2149 55.518 47.6496 55.518 48.1439C55.518 48.6377 55.3302 49.0647 54.9547 49.4249C54.5796 49.7851 54.1449 49.9651 53.6506 49.9651ZM46.9476 72.0601C43.8679 72.0601 40.993 71.4826 38.3227 70.3275C35.6524 69.1725 33.3237 67.6014 31.3365 65.6142C29.3494 63.627 27.7782 61.2936 26.6232 58.6138C25.4681 55.9341 24.8906 53.0637 24.8906 50.0024C24.8906 48.4872 25.0397 46.9968 25.3377 45.5313C25.6358 44.0657 26.0705 42.6623 26.6418 41.3209L28.3185 41.8426C27.772 43.1094 27.3684 44.4073 27.1076 45.7362C26.8468 47.0651 26.7163 48.4499 26.7163 49.8906C26.7163 55.5541 28.6725 60.3482 32.5847 64.2728C36.497 68.1975 41.2849 70.1599 46.9483 70.1599C52.5869 70.1599 57.3686 68.1975 61.2933 64.2728C65.2179 60.3482 67.1803 55.5541 67.1803 49.8906C67.1803 48.8409 67.0961 47.813 66.9277 46.807C66.7588 45.801 66.5449 44.8169 66.2861 43.8546C62.6595 43.5813 59.3371 42.6126 56.3191 40.9483C53.3011 39.2841 50.7115 37.0857 48.5505 34.3534L50.2272 33.3474C52.115 35.6823 54.3506 37.5887 56.9339 39.0667C59.5172 40.5447 62.349 41.47 65.4291 41.8426C64.3858 39.4331 62.9389 37.2969 61.0883 35.4339C59.2378 33.5709 57.0705 32.1426 54.5865 31.149L56.5986 30.0313C60.3245 31.8197 63.3363 34.4838 65.634 38.0234C67.9317 41.5631 69.0805 45.5437 69.0805 49.9651C69.0805 53.0264 68.503 55.8969 67.348 58.5766C66.1929 61.2563 64.6156 63.596 62.616 65.5956C60.6164 67.5952 58.275 69.1725 55.5918 70.3275C52.9086 71.4826 50.0272 72.0601 46.9476 72.0601ZM27.8714 40.2776L55.4062 29.7704C53.7668 27.6591 51.757 26.0755 49.3769 25.0198C46.9968 23.9641 44.4857 23.4363 41.8438 23.4363C37.6458 23.4363 34.2117 25.1316 31.5415 28.5222C28.8712 31.9129 27.6478 35.8313 27.8714 40.2776ZM26.0829 42.9976C25.9836 42.476 25.9339 41.973 25.9339 41.4886V39.9796C25.9339 36.0797 26.8902 32.5401 28.8029 29.3606C30.7155 26.1811 33.274 23.9083 36.4784 22.5421C36.4287 22.4675 36.4101 22.3868 36.4225 22.2999C36.4349 22.2129 36.4411 22.1322 36.4411 22.0577C36.4411 21.5336 36.6137 21.0981 36.959 20.7514C37.3048 20.4051 37.739 20.232 38.2616 20.232C38.6874 20.232 39.0741 20.3562 39.4219 20.6046C39.7696 20.853 40.0056 21.1883 40.1298 21.6106C40.403 21.5609 40.6817 21.5361 40.9659 21.5361H41.8438C44.899 21.5361 47.7742 22.2005 50.4694 23.5294C53.1645 24.8584 55.4435 26.7151 57.3065 29.0998L69.4159 24.5541L70.1238 26.3053L26.0829 42.9976Z"
      fill="#3D734A"
      stroke="#3D734A"
    />
  </svg>
);
